/*
 * 詳細画面定義コンポーネント
 */
<template>
<div class="more-detail" :class="sticky_element_class" style="overflow:hidden">
	<div class="layout-btn" v-if="r_btn_type == 0">
		<!-- ボタン非表示 -->
	</div>
	<div class="layout-btn" v-if="r_btn_type == 1">
		<!-- 確定ボタン -->
		<!-- <button class="btn-ok"
			@click="onBtnOK"
			v-if="r_is_disp_confirm_btn"
			v-bind:disabled="!r_is_confirm_enable"> {{r_messages.confirm_btn}} </button>
		<div v-else class="btn-space"></div> -->
		<button class="btn-ok"
			@click="onBtnOK"
			v-if="r_is_disp_confirm_btn"
			v-bind:disabled="!r_is_confirm_enable"><i class="fa-solid fa-check"></i></button>
		<div v-else class="btn-space"></div>
		<!-- 削除 -->
		<!-- <button class="btn-delete"
			@click="onBtnDelete(r_messages.delete_check_text)"
			v-if="r_is_disp_delete_btn"
			v-bind:disabled="!r_is_delete_enable"> {{r_messages.delete_btn}} </button> -->
			<button class="btn-delete"
				@click="onBtnDelete(r_messages.delete_check_text)"
				v-if="r_is_disp_delete_btn"
				v-bind:disabled="!r_is_delete_enable"><i class="fa fa-trash"></i></button>
		<div class="right">
			<!-- 更新ボタン（リロード） -->
			<!-- <button class="btn-restore" 
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable">
				<i class="fa fa-refresh"></i>   {{r_messages.restore_btn}}</button> -->
			<button class="btn-restore"
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable">
				<i class="fa-solid fa-rotate"></i>
			</button>
		</div>
	</div>
	<!-- 申請 -->
	<div class="layout-btn" v-else-if="( r_btn_type == 2 || r_btn_type == 3 ) && r_check_edit">
		<!-- 新規申請 -->
		<span v-if="r_btn_type == 2">
			<!-- 登録申請ボタン -->
			<button class="btn-ok"
				@click="onBtnOK"
				v-if="r_is_disp_confirm_btn"
				v-bind:disabled="!r_is_confirm_enable"> {{r_messages.registration_apply_btn}} </button>
			<div v-else class="btn-space"></div>
			<!-- 削除申請ボタン -->
			<button class="btn-delete" 
				@click="onBtnDelete(r_messages.delete_check_text)" 
				v-if="r_is_disp_delete_btn"
				v-bind:disabled="!r_is_delete_enable" > {{r_messages.delete_apply_btn}} </button>
			<!-- 新規追加 -->
			<button class="btn-ok" 
				@click="onBtnNewData" 
				v-if="r_is_disp_new_btn">
						{{r_messages.new_date_btn}}</button>
		</span>
		<!-- 申請編集 -->
		<span v-else>
			<!-- 申請ボタン -->
			<button class="btn-ok" 
				@click="onBtnOK"  
				v-bind:disabled="!r_is_confirm_enable"> {{r_messages.apply_btn}} </button>
			<span v-if="r_is_apply == true">
				<!-- 申請取り下げボタン -->
				<button class="btn-delete" 
					@click="onBtnDelete(r_messages.msg_app_discharge_check_text)" 
					v-bind:disabled="!r_is_delete_enable" > {{r_messages.apply_stop_btn}} </button>
			</span>
			<span v-if="r_is_apply == false">
				<!-- 予約取り下げボタン -->
				<button class="btn-delete" 
					@click="onBtnDelete(r_messages.msg_res_discharge_check_text)" 
					v-bind:disabled="!r_is_delete_enable" > {{r_messages.apply_stop_btn}} </button>
			</span>
			<!-- 新規追加 -->
			<button class="btn-ok" 
				@click="onBtnNewData" 
				v-if="r_is_disp_new_btn">
						{{r_messages.new_date_btn}}</button>	
		</span>
		<div class="right">
			<!-- 編集ボタン -->
			<button class="btn-ok" 
				@click="onBtnEditData"
				v-if="r_is_disp_edit_btn"> {{r_messages.edit}}</button>
			<!-- 更新ボタン（リロード） -->
			<!-- <button class="btn-restore" 
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable"> <i class="fa fa-refresh"></i>   {{r_messages.restore_btn}}</button> -->
			<button class="btn-restore" 
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable"> <i class="fa-solid fa-rotate"></i>   {{r_messages.restore_btn}}</button>
		</div>
	</div>
	<!-- 承認 -->
	<div class="layout-btn" v-else-if="r_btn_type == 4 && r_check_edit">
		<!-- 承認ボタン -->
		<button class="btn-ok" 
			@click="onBtnOK"  
			v-if="r_approval_btn_disp"
			v-bind:disabled="!r_is_confirm_enable"> {{r_messages.approval_btn}} </button>
		<!-- 否認ボタン -->
		<button class="btn-delete" 
			@click="onBtnDelete" 
			v-if="r_denial_btn_disp"
			v-bind:disabled="!r_is_delete_enable" > {{r_messages.denial_btn}} </button>
		<!-- 差戻し -->
		<button class="btn-restore" 
			@click="onBtnRestore"
			v-if="r_send_btn_disp"
			v-bind:disabled="!r_is_restore_enable"> {{r_messages.send_back_btn}}</button>
		<div class="right">
			<!-- 編集ボタン -->
			<button class="btn-ok" 
				@click="onBtnEditData"
				v-if="r_is_disp_edit_btn"> {{r_messages.edit}}</button>
			<!-- 更新ボタン（リロード） -->
			<!-- <button class="btn-restore" 
				@click="onBtnReload"
				v-if="r_restore_btn_disp"
				v-bind:disabled="!r_is_restore_enable"> <i class="fa fa-refresh"></i>   {{r_messages.restore_btn}}</button> -->
			<button class="btn-restore" 
				@click="onBtnReload"
				v-if="r_restore_btn_disp"
				v-bind:disabled="!r_is_restore_enable"> <i class="fa-solid fa-rotate"></i>   {{r_messages.restore_btn}}</button>
		</div>
	</div>
	<!-- システム連携あり ステータス:削除予定の場合 -->
	<div class="layout-btn" v-else-if="r_btn_type == 5">
		<!-- 確定ボタン -->
		<button class="btn-ok" 
			@click="onBtnDelete(r_messages.delete_check_text)" 
			v-if="r_is_disp_confirm_btn"
			v-bind:disabled="!r_is_confirm_enable"> {{r_messages.confirm_btn}} </button>
		<div v-else class="btn-space"></div>
		<!-- 削除取消 -->
		<button class="btn-delete" 
			@click="onBtnOK" > {{r_messages.delete_cancel_btn}} </button>
		<div class="right">
			<!-- 更新ボタン（リロード） -->
			<!-- <button class="btn-restore" 
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable"> <i class="fa fa-refresh"></i>   {{r_messages.restore_btn}}</button> -->
			<button class="btn-restore" 
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable"> <i class="fa-solid fa-rotate"></i>   {{r_messages.restore_btn}}</button>
			<!-- 削除ボタンスペース -->
			<div class="btn-space"></div>
		</div>
	</div>
	<!-- システム連携用 （登録・更新のみ） -->
	<div class="layout-btn" v-else-if="r_btn_type == 6">
		<!-- 登録ボタン -->
		<button class="btn-ok" 
			@click="onBtnOK"  
			v-bind:disabled="!r_is_confirm_enable"> {{r_messages.registration_btn}} </button>
		<div class="right">
			<!-- 更新ボタン（リロード） -->
			<!-- <button class="btn-restore" 
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable"> <i class="fa fa-refresh"></i>   {{r_messages.restore_btn}}</button> -->
			<button class="btn-restore" 
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable"> <i class="fa-solid fa-rotate"></i>   {{r_messages.restore_btn}}</button>
		</div>
	</div>
	<div class="layout-btn" v-if="r_btn_type == 7">
		<!-- 確定ボタン -->
		<button class="btn-ok"
			@click="onBtnOK"
			v-if="r_is_disp_confirm_btn"
			v-bind:disabled="!r_is_confirm_enable"><i class="fa-solid fa-check"></i></button>
		<div v-else class="btn-space"></div>
		<!-- コピーボタン -->
		<button class="btn-copy"
			@click="onBtnCopyNew"
			v-if="r_is_disp_copy_btn"
			v-bind:disabled="!r_is_copy_enable"><i class="fa-regular fa-copy"></i></button>
		<div v-else class="btn-space"></div>
		<!-- 削除 -->
		<button class="btn-delete"
			@click="onBtnDelete(r_messages.delete_check_text)"
			v-if="r_is_disp_delete_btn"
			v-bind:disabled="!r_is_delete_enable"><i class="fa fa-trash"></i></button>
		<div class="right">
			<!-- 更新ボタン（リロード） -->
			<button class="btn-restore"
				@click="onBtnRestore"
				v-bind:disabled="!r_is_restore_enable">
				<i class="fa-solid fa-rotate"></i>
			</button>
		</div>
	</div>
</div>
</template>
<script>
	/**
	 * 詳細画面で仕様するボタン定義.<br>
	 * @module js/parts_com/btnsWndDetail
	 * @example
	 * <c-btns-wnd-detail 
	 * 	:r_messages = "r_messages"
	 * 	:is_new="false" 
	 * 	v-on:event_close="onClose" 
	 * >
	 * </c-btns-wnd-detail>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_messages - 表示文言
	 * @param {object} r_info - 編集するデータ
	 **/
	 export default {
		props:{
			'r_messages':{},
			'r_btn_type':{
				type: Number,
				default: 1,
			},
			'r_is_apply':Boolean,
			'r_is_confirm_enable':Boolean,
			'r_is_copy_enable':Boolean,
			'r_is_delete_enable':Boolean,
			'r_is_restore_enable':Boolean,
			'r_check_edit':Boolean,
			'r_is_disp_confirm_btn':{
				type: Boolean,
				default: true,
			},
			'r_is_disp_copy_btn':{
				type: Boolean,
				default: true,
			},
			'r_is_disp_delete_btn':{
				type: Boolean,
				default: true,
			},
			'r_is_disp_new_btn':Boolean,
			'r_is_disp_edit_btn':Boolean,
			'r_is_disp_errdetail_btn':{
				type: Boolean,
				default: false,
			},
			
			'r_approval_btn_disp':{
				type: Boolean,
				default: true,
			},
			'r_denial_btn_disp':{
				type: Boolean,
				default: true,
			},
			'r_send_btn_disp':{
				type: Boolean,
				default: true,
			},
			'r_edit_btn_disp':{
				type: Boolean,
				default: true,
			},
			'r_restore_btn_disp':{
				type: Boolean,
				default: true,
			},
			'r_is_sticky_class':{
				type:Boolean,
				default: true,
			},
		},
		computed: {
			// 固定要素クラス指定(position:sticky)
			sticky_element_class: function() {
				return (this.r_is_sticky_class) ? 'sticky-element-area' : '';
			},
		},
		methods: {
			/**
			 *  OKボタン <br>
			 * ******* 内部処理 *******<br>
			 *
			 * @function  onBtnOK
			 * @instance
			 */
			onBtnOK: function(){
				this.$emit("event_btnoK");
			},
			/**
			 *  コピーボタン <br>
			 * ******* 内部処理 *******<br>
			 *
			 * @function  onBtnCopyNew
			 * @instance
			 */
			onBtnCopyNew: function(){
				this.$emit("event_btncopy_new");
			},
			/**
			 * 削除ボタン <br>
			 * ******* 内部処理 *******<br>
			 * postDataに引数（消去）を渡し、呼ぶ。 <br>
			 *
			 * @function  onBtnDelete
			 * @instance
			 */
			onBtnDelete: function(msgConfirm){
				this.$emit("event_btndelete",msgConfirm);
			},
			/**
			 * 更新ボタン（リロード）
			 * 
			 * @instance
			 */
			onBtnRestore: function(){
				this.$emit("event_btnrestore");
			},
			/**
			 * 更新ボタン（リロード）(他ボタンと兼用は無し)
			 * 
			 * @instance
			 */
			onBtnReload: function(){
				this.$emit("event_btnreload");
			},
			/**
			 * 新規追加ボタン
			 * 
			 * @instance
			 */
			onBtnNewData: function(){
				this.$emit("event_btnnewdata");
			},
			/**
			 * 変更ボタン
			 * 
			 * @instance
			 */
			onBtnEditData: function(){
				this.$emit("event_btneditdata");
			},
			/**
			 * エラー詳細ボタン
			 * 
			 * @instance
			 */
			onBtnErrDetail: function(){
				this.$emit("event_btnerrdetail");
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/btnsWndDetail.vue